export default __webpack_public_path__ + "static/media/building-wall-color-set-on.43464748.svg";